import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { getConsent, setConsent } from "@/lib/consent";
import { Cookie } from "lucide-react";

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  if (!visible) return null;

  const acceptAll = () => {
    setConsent({ analytics: true, marketing: true });
    setVisible(false);
  };
  const rejectAll = () => {
    setConsent({ analytics: false, marketing: false });
    setVisible(false);
  };
  const saveCustom = () => {
    setConsent({ analytics, marketing });
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Consentimiento de cookies"
      className="fixed z-[100] bottom-2 right-2 left-2 sm:left-auto sm:bottom-3 sm:right-3"
    >
      <div className="mx-auto sm:mx-0 max-w-xs rounded-lg border bg-card/95 text-card-foreground shadow-md backdrop-blur supports-[backdrop-filter]:bg-card/90">
        <div className="p-2">
          {!showDetails ? (
            <div className="flex items-center gap-1.5">
              <Cookie className="h-3.5 w-3.5 text-primary shrink-0" aria-hidden />
              <p className="text-[11px] text-muted-foreground flex-1 min-w-0 leading-tight">
                Cookies.{" "}
                <Link to="/privacy-policy" className="underline hover:text-foreground">+info</Link>
              </p>
              <Button size="sm" variant="ghost" className="h-6 px-1.5 text-[11px]" onClick={rejectAll}>No</Button>
              <Button size="sm" variant="ghost" className="h-6 px-1.5 text-[11px]" onClick={() => setShowDetails(true)}>•••</Button>
              <Button size="sm" className="h-6 px-2 text-[11px]" onClick={acceptAll}>OK</Button>
            </div>
          ) : (
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Cookie className="h-4 w-4 text-primary shrink-0" aria-hidden />
                <h2 className="font-semibold text-sm">Preferencias de cookies</h2>
              </div>
              <div className="space-y-2 rounded-lg border bg-muted/40 p-2.5">
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <Label className="text-xs">Esenciales</Label>
                    <p className="text-[11px] text-muted-foreground">Sesión y seguridad.</p>
                  </div>
                  <Switch checked disabled aria-label="Esenciales (siempre activas)" />
                </div>
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <Label htmlFor="c-analytics" className="text-xs">Analítica</Label>
                    <p className="text-[11px] text-muted-foreground">Medición de uso.</p>
                  </div>
                  <Switch id="c-analytics" checked={analytics} onCheckedChange={setAnalytics} />
                </div>
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <Label htmlFor="c-marketing" className="text-xs">Marketing</Label>
                    <p className="text-[11px] text-muted-foreground">Publicidad personalizada.</p>
                  </div>
                  <Switch id="c-marketing" checked={marketing} onCheckedChange={setMarketing} />
                </div>
              </div>
              <div className="flex flex-wrap gap-1.5 justify-end">
                <Button size="sm" variant="ghost" className="h-7 px-2 text-xs" onClick={rejectAll}>Rechazar</Button>
                <Button size="sm" variant="outline" className="h-7 px-2 text-xs" onClick={saveCustom}>Guardar</Button>
                <Button size="sm" className="h-7 px-3 text-xs" onClick={acceptAll}>Aceptar todas</Button>
              </div>
              <p className="text-[10px] text-muted-foreground text-center">
                <Link to="/privacy-policy" className="underline hover:text-foreground">Política de Privacidad</Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
